import { startOfToday } from 'date-fns';
import getDateMonthAndYear from './getDateMonthAndYear';
export default function getCurrentYearMonthAndDate() {
  return getDateMonthAndYear(startOfToday());
}
//# sourceMappingURL=getCurrentYearMonthAndDate.js.map